<template>
    <div
        class="item"
        @mouseover="mouseover"
        @mouseleave="mouseleave"
        @click="mouseClick"
    >
        <div ref="menuTop" class="catalog-main">
            Каталог товаров
        </div>
        <ul ref="menuBox" :class="[showMenu ? 'open' : '', 'menu-box']">
            <div class="menu-box-inn">
                <div
                    class="level-0 pretty-scroll"
                    :style="{ height: `${parseInt(heightMenu)}px` }"
                >
                    <Item
                        v-for="(item, index) in treeData.childrens"
                        :key="index"
                        :model="item"
                    />
                </div>
                <div
                    v-if="submenu.list != null"
                    class="submenu pretty-scroll"
                    :style="{ height: `${parseInt(heightMenu)}px` }"
                >
                    <li v-if="!submenu.isCatalog" class="top">
                        <a :href="submenu.parentUrl">Все товары раздела</a>
                    </li>
                    <Item
                        v-for="(item, index) in submenu.list"
                        :key="index"
                        :model="item"
                    />
                </div>
                <div
                    v-if="submenu2.list != null"
                    class="submenu2 pretty-scroll"
                    :style="{ height: `${parseInt(heightMenu)}px` }"
                >
                    <li v-if="!submenu2.isCatalog" class="top">
                        <a :href="submenu2.parentUrl">Все товары раздела</a>
                    </li>
                    <Item
                        v-for="(item, index) in submenu2.list"
                        :key="index"
                        :model="item"
                    />
                </div>
                <div
                    v-if="submenu3.list != null"
                    class="submenu3 pretty-scroll"
                    :style="{ height: `${parseInt(heightMenu)}px` }"
                >
                    <li v-if="!submenu3.isCatalog" class="top">
                        <a :href="submenu3.parentUrl">Все товары раздела</a>
                    </li>
                    <Item
                        v-for="(item, index) in submenu3.list"
                        :key="index"
                        :model="item"
                    />
                </div>
            </div>
        </ul>
    </div>
</template>

<script>
    import Item from './Item.vue';

    export default {
        components: {
            Item: Item,
        },
        data() {
            return {
                showMenu: false,
                heightMenu: 0,
                closeTimer: null,
                load: false,
            };
        },
        computed: {
            treeData() {
                return this.$store.state.menulist;
            },
            submenu() {
                return this.$store.state.level1;
            },
            submenu2() {
                return this.$store.state.level2;
            },
            submenu3() {
                return this.$store.state.level3;
            },
        },
        mounted() {
            this.$nextTick(function () {
                this.getTree();
            });
            this.calculateHeightMenu();
        },
        methods: {
            calculateHeightMenu() {
                if (!this.showMenu) {
                    const marginTopMenu =
                        this.$refs.menuTop.getBoundingClientRect().top;
                    const correctorHeight = 60;
                    const MAX_HEIGHT = 590; // @todo лучшего решения пока не нашел
                    const actualHeight =
                        window.innerHeight - marginTopMenu - correctorHeight;

                    this.heightMenu =
                        MAX_HEIGHT < actualHeight ? MAX_HEIGHT : actualHeight;
                }
            },
            mouseover() {
                clearTimeout(this.closeTimer);
                this.closeTimer = setTimeout(() => {
                    this.calculateHeightMenu();
                    this.showMenu = true;
                    $('html').css('overflow', 'hidden');
                    $('body').css('overflowY', 'scroll').addClass('hidden');
                }, 500);
            },
            mouseClick() {
                clearTimeout(this.closeTimer);
                !this.showMenu && this.calculateHeightMenu();
                this.showMenu = !this.showMenu;
                if (this.showMenu) {
                    $('html').css('overflow', 'hidden');
                    $('body').css('overflowY', 'scroll').addClass('hidden');
                } else {
                    $('html').css('overflow', 'auto');
                    $('body').css('overflowY', 'auto').removeClass('hidden');
                }
            },
            mouseleave() {
                clearTimeout(this.closeTimer);
                this.closeTimer = setTimeout(() => {
                    this.showMenu = false;
                    this.$store.commit('clearLevel');
                    $('.level-0').find('li.active').removeClass('active');
                    $('html').css('overflow', 'auto');
                    $('body').css('overflowY', 'auto').removeClass('hidden');
                }, 500);
            },
            getTree() {
                var _this = this;

                if (!this.load) {
                    this.$store.dispatch('getList').then(function () {
                        _this.load = true;
                    });
                }
            },
        },
    };
</script>
